// @flow

import { h }             from "preact";
import { PureComponent } from "shared-components";
import styles            from "./styles.scss";
import classNames        from "classnames";

import Checkbox from "../Checkbox";

export default class QtyPicker extends PureComponent {
  props: Props;

  render({ acceptTransaction, acceptedTransaction, disabled, grandTotal }: Props, state: any, { formatPrice, t }: Context) {
    return (
      <div
          class={classNames(
            this.props["class"],
            styles.block
          )}>

        <Checkbox
            name="terms"
            disabled={disabled}
            value={acceptedTransaction}
            onChange={acceptTransaction}>

          <div
              dangerouslySetInnerHTML={{
                __html: t("CHECKOUT.ACCEPT", {
                  price: formatPrice(grandTotal)
                })
              }}
          />
        </Checkbox>
      </div>
    );
  }
}
